import { render, staticRenderFns } from "./CustomerProfileDetailsView.vue?vue&type=template&id=71f3fe27&"
import script from "./CustomerProfileDetailsView.vue?vue&type=script&lang=js&"
export * from "./CustomerProfileDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfileDetailsView.vue?vue&type=style&index=0&id=71f3fe27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports